import { LanguageDto, ResourcesDto } from 'common/api/autogenerated/trading-gateway';

const resourcesInitialState: {
  languages: LanguageDto[];
  labels: ResourcesDto['resources'];
  loading: boolean;
  initLoading: boolean;
  culture: string;
} = {
  labels: {},
  languages: [],
  loading: true,
  initLoading: true,
  culture: '',
};

export { resourcesInitialState };
